import { HelpCircle, ArrowRight, BadgeDollarSign, Tags, Wallet, Target, Sparkles } from "lucide-react";
import { SectionHead, Reveal } from "./shared";
import { Trident } from "./Logo";

const QUESTIONS = [
  { icon: BadgeDollarSign, q: "Quanto posso pagar por esse lote?" },
  { icon: Tags, q: "Até onde posso remarcar?" },
  { icon: Wallet, q: "Quanto realmente sobra?" },
  { icon: Target, q: "Quanto preciso faturar?" },
  { icon: Sparkles, q: "Quando começo a gerar lucro?" },
];

export const Decisions = () => (
  <section id="decisoes" data-testid="decisions-section" className="relative bg-tria-navy/50 py-24 sm:py-32">
    <div className="pointer-events-none absolute bottom-0 left-1/2 h-[320px] w-[640px] -translate-x-1/2 rounded-full bg-tria-vivid/10 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Tomada de decisão"
        testId="decisions-head"
        title={<>Transforme dados em <span className="text-gradient-blue">decisões</span></>}
        sub="Com a TRIA, o gestor deixa de acompanhar apenas o saldo da conta e passa a administrar por indicadores claros."
      />

      <div className="mx-auto grid max-w-5xl items-center gap-8 lg:grid-cols-[1fr_auto_1fr]">
        <div className="flex flex-col gap-3">
          {QUESTIONS.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.07}>
              <div
                data-testid={`decision-question-${i + 1}`}
                className="group flex items-center gap-3.5 rounded-xl border border-white/[0.07] bg-white/[0.02] px-5 py-4 transition-all duration-300 hover:border-tria-sky/30 hover:bg-tria-sky/[0.04]"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-tria-vivid/15 text-tria-sky">
                  <item.icon className="h-4 w-4" />
                </span>
                <span className="text-[14px] font-semibold text-white">{item.q}</span>
                <HelpCircle className="ml-auto h-4 w-4 shrink-0 text-tria-subtle transition-colors group-hover:text-tria-sky" />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="flex justify-center">
          <div className="relative flex flex-col items-center gap-4">
            <div className="hidden flex-col items-center gap-1 lg:flex">
              <ArrowRight className="h-5 w-5 rotate-180 text-tria-blue/60" />
            </div>
            <div className="glow-blue flex h-24 w-24 animate-pulse-glow items-center justify-center rounded-3xl border border-tria-sky/30 bg-tria-card" data-testid="decisions-core">
              <Trident id="decisions" className="h-12 w-12" />
            </div>
            <ArrowRight className="hidden h-5 w-5 text-tria-blue/60 lg:block" />
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <div data-testid="decisions-output" className="rounded-2xl border border-tria-sky/25 bg-gradient-to-br from-tria-vivid/[0.12] to-transparent p-7">
            <span className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-tria-sky">Resposta da plataforma</span>
            <h3 className="mt-3 font-display text-xl font-semibold leading-snug text-white">
              Indicadores que respondem antes da decisão
            </h3>
            <p className="mt-3 text-[13.5px] leading-relaxed text-tria-mist">
              Cada pergunta encontra um número: margem do lote, ponto de equilíbrio, resultado
              operacional e potencial remanescente. A decisão deixa de ser aposta e vira método.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["Compra", "Preço", "Remarcação", "Metas", "Lucro"].map((t) => (
                <span key={t} className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-1 font-mono text-[10.5px] font-semibold text-tria-mist">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
